const objectIsEmpty = (obj) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key))
      return false
  }
  return true
}

export const prospectIsEmpty = (prospectState) => {
  const {
    prospect
  } = prospectState
  return objectIsEmpty(prospect)
}

export const financialAccountsIsEmpty = (financialAccountsState) => {
  const {
    financialAccountsLoaded
  } = financialAccountsState
  return !financialAccountsLoaded
}

export const arrayIsEmpty = array => (array.length === 0)



// WEBPACK FOOTER //
// ./src/utils/storeUtils.js